import { Link } from "react-router-dom";
import { FileText, ArrowLeft } from "lucide-react";

const TerminosServicio = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-primary-50/20 to-secondary-50/20 py-8 px-4">
      <div className="max-w-3xl mx-auto">
        <Link to="/login" className="inline-flex items-center gap-2 text-slate-600 hover:text-primary text-sm mb-6">
          <ArrowLeft size={18} /> Volver
        </Link>
        <div className="glass-panel p-6 sm:p-10">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
              <FileText size={24} className="text-primary" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-slate-800">Condiciones del Servicio</h1>
              <p className="text-slate-500 text-sm">Ecosistema WCA – World Community Academy</p>
            </div>
          </div>

          <div className="prose prose-slate max-w-none text-sm sm:text-base text-slate-600 space-y-6">
            <p className="text-slate-500 text-xs">Última actualización: febrero 2026</p>

            <section>
              <h2 className="text-lg font-semibold text-slate-800 mt-6 mb-2">1. Aceptación</h2>
              <p>Al acceder y utilizar la plataforma Ecosistema WCA («la Plataforma»), usted acepta las presentes Condiciones del Servicio. Si no está de acuerdo con ellas, no debe utilizar la Plataforma.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-800 mt-6 mb-2">2. Descripción del servicio</h2>
              <p>La Plataforma es un entorno de gestión interna (información general, avisos, calendario, módulos por direcciones y divisiones, recursos compartidos, etc.) destinado a usuarios autorizados de World Community Academy. El acceso está condicionado a la activación de la cuenta por el administrador.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-800 mt-6 mb-2">3. Cuenta y uso</h2>
              <p>Usted es responsable de mantener la confidencialidad de su sesión y de la actividad realizada con su cuenta. Debe utilizar la Plataforma de forma lícita y conforme a las instrucciones y políticas internas que se le comuniquen. No está permitido el uso no autorizado, la suplantación de identidad ni el acceso a áreas o datos para los que no tenga permiso.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-800 mt-6 mb-2">4. Funcionalidades de terceros</h2>
              <p>La Plataforma puede integrar servicios de terceros (por ejemplo, inicio de sesión con Google y, si usted lo autoriza, la vinculación con Google Calendar). El uso de esos servicios está sujeto además a las políticas y condiciones del proveedor correspondiente.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-800 mt-6 mb-2">5. Contenido y propiedad</h2>
              <p>Los contenidos y materiales puestos a disposición en la Plataforma son propiedad de World Community Academy o de sus titulares. No se concede ningún derecho de propiedad intelectual más allá del uso interno autorizado.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-800 mt-6 mb-2">6. Disponibilidad y modificaciones</h2>
              <p>Nos esforzamos por mantener la Plataforma disponible, pero no garantizamos una disponibilidad ininterrumpida. Nos reservamos el derecho de modificar, suspender o discontinuar funcionalidades con un aviso razonable cuando sea posible. Los cambios sustanciales en estas condiciones se comunicarán o se reflejarán en esta página.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-800 mt-6 mb-2">7. Limitación de responsabilidad</h2>
              <p>En la medida permitida por la ley aplicable, la Plataforma se ofrece «tal cual». No seremos responsables de daños indirectos, consecuentes o punitivos derivados del uso o la imposibilidad de uso del servicio, salvo que la ley exija lo contrario.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-slate-800 mt-6 mb-2">8. Contacto</h2>
              <p>Para dudas sobre estas condiciones puede contactar a: <a href="mailto:contacto@ecosistemawca.com" className="text-primary hover:underline">contacto@ecosistemawca.com</a>.</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TerminosServicio;
